export default __webpack_public_path__ + "img/beaver.aeb01162.svg";